<template>
  <div>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        Policy Helplist
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-card>
          <v-flex xs12>
            <form>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.polNo"
                                :label="labels.polNo"
                                :error-messages="errors.collect('polNo')"
                                data-vv-name="polNo"
                                :data-vv-as="labels.polNo"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.renCnt"
                                :label="labels.renCnt"
                                :error-messages="errors.collect('renCnt')"
                                data-vv-name="renCnt"
                                :data-vv-as="labels.renCnt"
                                v-validate="'numeric'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.endtCnt"
                                :label="labels.endtCnt"
                                :error-messages="errors.collect('endtCnt')"
                                data-vv-name="endtCnt"
                                :data-vv-as="labels.endtCnt"
                                v-validate="'numeric'"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                        <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </form>
          </v-flex>
        </v-card>
        <v-spacer class="mt-3"></v-spacer>
        <v-card>
          <V-card-title>
            <div class="headline">Policies List</div>
          </V-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              v-bind:options.sync="pagination"
              :server-items-length="totalItems"
              :loading="loading"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.polNo }}</td>
                  <td class="text-xs-left">{{ row.item.renCnt }}</td>
                  <td class="text-xs-left">{{ row.item.endtCnt }}</td>
                  <td class="text-xs-center">
                    <v-btn text icon color="primary" type="submit" @click.native="doSelect(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr></template
              >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
export default {
  data() {
    return {
      toogleArray: [false],
      labels: {
        polNo: 'Policy No.',
        renCnt: 'Renewal Count',
        endtCnt: 'Endorsement Count'
      },
      filters: {
        polNo: null,
        renCnt: null,
        endtCnt: null
      },
      headers: [
        { text: 'Policy No.', value: 'polNo' },
        { text: 'Renewal Count', value: 'renCnt' },
        { text: 'Endorsement Count', value: 'endtCnt' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      totalItems: 0,
      pagination: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  created() {
    this.fetchData(true)
  },
  methods: {
    async fetchData(options) {
      const apiURI = this.apiURI
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          this.items = []
          if (result.data) {
            const { data } = result.data
            this.totalItems = result.data.totalElements
            if (data) {
              data.map((polMaster) => {
                const convertList = {
                  polNo: polMaster.polNo,
                  renCnt: polMaster.renCnt,
                  endtCnt: polMaster.endtCnt
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
        }
      }
    },
    doSelect(data) {
      const result = {
        polNo: data.polNo,
        renCnt: data.renCnt,
        endtCnt: data.endtCnt
      }
      this.$emit('select', result)
      this.$emit('close')
    },
    doClearFilters() {
      this.filters.polNo = null
      this.filters.renCnt = null
      this.filters.endtCnt = null
      this.fetchData(false)
    },
    doFilters() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    }
  },
  computed: {},
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  mixins: [TableConst.default, MessageMixin],
  props: {
    apiURI: String
  }
}
</script>

<style>
</style>
